/**
 * Show general device info
 *
 * This is a stub function for demonstrating the functionality
 * of the device lookup menu. Replace it with something more functional
 */
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import DeviceDetailLayout from '@/views/device_detail';
import DeviceView from '@/views/device';
import DeviceHistoryView from '@/views/device_history';
import DeviceLogLayout from '@/views/device_log_layout';
import DeviceDataView from '@/views/dashboard/widgets/bandwidth';
import device_summary_tmpl from '@/../templates/device-summary.hbs';
import device_detail_tmpl from '@/../templates/device-detail-view.hbs';

var globalCh = Radio.channel('global');
var routerCh = Radio.channel('router');
var content_views = {
    detail: create_detail_view,
    logs: create_log_view,
    data: create_device_data_view,
    history: create_history_view
};
var DetailsDeviceView = DeviceView.extend({
    v5_object_regions : function(){
        return [
            { name: 'owner', model: this.model.rel.get('owner'), link: false },
            { name: 'product', model: this.model.rel.get('product'), link: false },
            { name: 'group', model: this.model.rel.get('devicegroup'), link: true }
        ];
    },
    ui: {
        item_id: '.item-id .details',
        checkbox: 'input[type="checkbox"]',
        restart: '.actions .restart',
        assign: '.actions .assign',
        edit: '.actions .edit',
        unassign: '.actions .unassign',
        delete: '.actions .delete',
        group: '.group',
        owner: '.owner',
        account: '.account',
        product: '.product',
        code: '.actions .code',
        download_code: '.download-code',
        tooltips: '[data-toggle="tooltip"]'
    },
    regions: {
        group: '@ui.group',
        owner: '@ui.owner',
        account: '@ui.account',
        product: '@ui.product',
    },
});

function create_detail_view(device, device_detail_layout) {
    var device_view =  new DetailsDeviceView({
        tagName: 'div',
        template: Handlebars.compile(device_detail_tmpl),
        model: device,
        templateContext: function () {
            if ( this.model.get('agent_running') != true ) this.model.set('agent_running', false);
            const devicegroup = device.rel.get('devicegroup');
            const deployment = this.model.rel.get('deployment') || false;
            const can_download_code = deployment && deployment.can_download_code(devicegroup);
            const is_cellular = this.model.get('imp_type') === 'impC001';

            return {
                deployment_sha: deployment && deployment.get('sha') || 'n/a',
                status: this.model.get('device_online') ? 'online' : 'offline',
                can_download_code,
                is_cellular,
            };
        }
    });
    device_detail_layout.showChildView('content', device_view);
}

function create_log_view(device, device_detail_layout) {
    var device_log_layout = new DeviceLogLayout({
        model: device
    });
    device_detail_layout.showChildView('content', device_log_layout);
    return device_detail_layout;
}

function create_device_data_view(device, device_detail_layout) {
    var d = new Date();
    var end_date = new Date( Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 11, 59, 59 ) );

    var device_data_view = new DeviceDataView({
        columns: 12,
        model: device.bandwidth,
        data_types: ['dbo', 'dbi'],
        title: 'Device Bandwidth',
        ylabel: 'Bytes',
        colors: ['#21ABD4', '#FF9F4A'],
        date: end_date
    });
    device.bandwidth.fetch_day(null, new Date(), 'days').then( function(){
        device_detail_layout.showChildView('content', device_data_view);
    });
    return device_data_view;
}

function create_history_view(device, device_detail_layout) {
    var device_history_view = new DeviceHistoryView({ device: device });
    device_detail_layout.showChildView('content', device_history_view);
    return device_history_view;
}

function show_tab_content(tab_name, device, parent_view) {
    content_views[tab_name].call(this, device, parent_view);
}

/**
 * Takes a device and a tab. Tab should be 'device', 'log', 'history' or 'data'
 */
function show_device(device, tab) {
    globalCh.request('show_secondary_nav', { empty: true });
    routerCh.request('set_location', 'device', device);
    globalCh.request('set_selection', {
        type: 'device',
        id: device.id,
        v5_object: device
    });

    var options = {
        wait: true
    };

    // Load deployments first without the code, can't do load_all now
    device.load(options)
        .then(function(){
            device.rel.get('deployment') && device.rel.get('deployment').fetch({
                data: {
                    nocode: true
                }
            })
            // Render after fetch completed for deployment
            .done(function(){
                content_views[tab].call(this, device, device_detail_layout);
            });
            device.rel.get('owner') && device.rel.get('owner').load();
            device.rel.get('product') && device.rel.get('product').load();
            device.rel.get('devicegroup') && device.rel.get('devicegroup').load();
        });

    var app_layout = globalCh.request('app_layout');
    var device_detail_layout = new DeviceDetailLayout({
        childViewEvents: {
            'tab:clicked': function (tab_name) {
                show_tab_content.call(this, tab_name, device, this);
            },
        },
        model: device
    });

    // Create the Summary (top info) view
    var summary = new DetailsDeviceView({
        tagName: 'ul',
        template: Handlebars.compile(device_summary_tmpl),
        model: device,
        show: { 
            rel_owner: false,
            rel_account: false,
            rel_devicegroup: false,
            rel_product: false,
        },
    });

    // Create a view based on what was passed to us for 'tab'
    // The detail, logs, and history views might better be built in controllers
    // that call this setup controller

    var content_views = {
        detail: create_detail_view,
        log: create_log_view,
        data: create_device_data_view,
        history: create_history_view
    };
    if (!(tab in content_views)) tab = 'detail';

    app_layout.showChildView('container', device_detail_layout);
    content_views[tab].call(this, device, device_detail_layout);

    device_detail_layout.showChildView('summary', summary);
}
export default show_device;

